
import { Observer } from 'mobx-vue'
import { Component, Prop, Vue, Provide, Inject } from 'vue-property-decorator'
import Product from './views/product.vue'
import EmptyComp from '@xt/www/components/system/empty.vue'
import WxImgPop from '@xt/www/components/wxImgPop/index.vue'
import { Bind, Debounce } from 'lodash-decorators'
import EmptyStatus from '@xt/www/components/emptyStatus/index.vue'
import { EnumEmptyStatus } from '@xt/client/utils/empty-status/index'
import { reportEntryLog } from '@xt/client/utils/log'

@Observer
@Component({
  components: { Product, EmptyComp, WxImgPop, EmptyStatus },
  name: 'allcourse'
})
export default class Page extends Vue {
  loading = true
  isError: boolean = false
  allCourseInfo: any = []
  haveNoneCourse = false

  // 日课去学习
  dayIsVisibleGolearn = false
  // 展览去学习
  showPopData = {
    visible: false,
    qrcode: '',
    subTitle: '',
    title: ''
  }

  get EnumEmptyStatus() {
    return EnumEmptyStatus
  }

  get PageStore() {
    return this.$store.$my
  }

  @Debounce(300, { leading: true, trailing: false })
  @Bind()
  async onLoading() {
    try {
      this.loading = true
      this.allCourseInfo = await this.PageStore.onGetMyAllProduct()
      if (this.allCourseInfo.length <= 0) {
        this.haveNoneCourse = true
      }
      this.isError = false
    } catch (error) {
      reportEntryLog('allcourse.loading-data.fail', { error })
      this.isError = true
    } finally {
      this.loading = false
    }
  }

  @Debounce(500, { leading: true, trailing: false })
  @Bind
  async handleShowCoursePop(payload: { type: 'activity' | 'show-prepare' | 'show-looking'; id: string | number }) {
    if (payload.type === 'activity') {
      this.dayIsVisibleGolearn = true
    } else if (payload.type === 'show-prepare') {
      // 去备展
      const qrcodeUrl = await this.$store.$storeShow.getQrcodeUrl({
        page: 'pages/levels/index',
        query: `id=${payload.id}`
      })
      this.showPopData = {
        qrcode: qrcodeUrl,
        title: '去备展',
        subTitle: '扫码后，学习展览辅导课',
        visible: true
      }
    } else if (payload.type === 'show-looking') {
      // 去观展
      const qrcodeUrl = await this.$store.$storeShow.getQrcodeUrl({
        page: 'pages/lookingEx/index',
        query: `id=${payload.id}`
      })
      this.showPopData = {
        qrcode: qrcodeUrl,
        title: '去观展',
        subTitle: '扫码后，去看同学的参展作品',
        visible: true
      }
    }
  }

  handleCloseShowPop() {
    // 这里没有closed事件，清除其他数据可能在弹窗关闭中途展示出中间状态 所以其他字段先不修改为中间态
    this.showPopData.visible = false
  }

  created() {
    this.onLoading()
  }
}
